import * as React from "react";

import {ComponentLink,
        makeChain}     from "@Common/react/cst2";
import {Types}         from "@Common/types";
import {Responsive}    from "@Common/ui-components/responsive"; // TODO: Update to use Responsive2 from ui-components/responsive-2


export const IsMobile = ({
    next: rootNext
}:{
    next            : (status:boolean) => void,
}) => (

    makeChain<JSX.Element>()

    // use responsive component to change functionality for mobile
    .then("responsive", (_, next:ComponentLink<typeof Responsive>) => (
        <Responsive next={next} sizes={{mobile: 640}}/>
    ))

    .then(({responsive}) => rootNext(
        responsive.lt("mobile") // treat all small widths as mobile
        || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) // browser check for mobile to handle landscape orientation
    ))

    .run()

);
